import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";
import { backendPatch, backendPost } from "services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useContractActions() {
  const [backendData, setBackendData] = useRecoilState(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state = backendData?.data ? backendData : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "contract-list",
      data: data,
    });
  };

  const uploadObjectList = async (form_data) => {
    form_data.api_version = "v2";

    await backendPost("data/objekts/upload", {
      label: "Objektliste",
      toSend: form_data,
      enqueueSnackbar,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res);
      },
    });
  };

  const updateAssignedClerk = async (contract_id, form_data) => {
    return await backendPatch(`data/vertrags/${contract_id}/assigned-clerk`, {
      label: "Sachbearbeiter",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "Sachbearbeiter wurde aktualisiert.",
      setResult: (res) => {
        const updated_contract = res?.data ?? res;
        updateListItemState(backendData, setBackendData, updated_contract);
      },
    });
  };

  const replaceAssignedClerkGlobally = async (form_data) => {
    return await backendPatch(`data/vertrags/assigned-clerk/replace`, {
      label: "Sachbearbeiter",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "Sachbearbeiter wurde global ersetzt.",
    });
  };

  return {
    replaceAssignedClerkGlobally,
    updateAssignedClerk,
    uploadObjectList,
    setState,
    state,
  };
}
